<template>
    <div class="content-box">
        <h3 class="text-color-error font12px mb10">以下维度筛选中无产品，无法对比Kpi数据：</h3>
        <div class="list-wrap font12px">
            <div class="mb10" v-for="item in data" :key="item.account_id||item">
                <p>{{item}}</p>
            </div>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">关闭</el-button>
        </p>
    </div>
</template>

<script>
    export default {
        name: "DetailInfoModal",
        props:{
            data:Object,
        },
        data(){
            return {
            };
        },
        methods:{
            hideModal(){
                this.$emit('close');
            },
        },
    }
</script>

<style lang="scss" scoped>
    .list-wrap{
        padding-left: 6px;
        max-height: 300px;
        overflow-y: auto;
    }
</style>
